module.exports = __webpack_public_path__ + "img/product-28.a772ad2a.jpg";